import { useEffect, useMemo, useState } from 'react';
import MantineTable from '../../../../../common/table/mantine';
import moment from 'moment';
import { axios } from '../../../../../utils/axios';
import { useParams } from 'react-router-dom';
import { showAlert } from '../../../../../utils/alerts';
import { Select, Space } from '@mantine/core';

export const Recon = () => {
  const { crNumber } = useParams();
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(undefined);

  useEffect(() => {
    fetch();
  }, [crNumber]);

  const fetch = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`/costing-request/recon-view/${crNumber}`);
      const response = data?.data;
      if (response) {
        const buyingCountries = Object.keys(response);
        setCountries(buyingCountries);
        setSelectedCountry(buyingCountries?.[0] || undefined);
        setData(response);
      }
    } catch (e) {
      showAlert(e, 'error');
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: 'condition_type',
        header: 'Conditions/Country',
      },
      {
        accessorKey: 'producing_country',
        header: 'Producing Country (InZone)',
      },
      {
        accessorKey: 'intermediary_country',
        header: 'Intermediary Country (Elbe)',
      },
      {
        accessorKey: 'buying_country',
        header: 'Buying Country (Elbe)',
      },
    ],
    [data, selectedCountry],
  );

  const rightButtons = [
    {
      button: (
        <Select
          name='country'
          label=''
          placeholder='Select country'
          value={selectedCountry}
          data={countries}
          withAsterisk
          disabled={loading}
          onChange={(value) => setSelectedCountry(value)}
        />
      ),
    },
  ];

  return (
    <>
      <Space h='md' />
      <MantineTable
        columns={columns}
        initialData={data && data[selectedCountry] ? data[selectedCountry] : []}
        unique='id'
        enableRowSelection={false}
        loading={loading}
        enablePagination={false}
        enableBottomToolbar={false}
        showSelectedToggle={false}
        hideSelectColumn={true}
        showResetAll={false}
        enableExport={true}
        rightButtons={rightButtons}
        csvFilename={`recon_view_${moment().format('YYYY-MM-DD')}`}
      />
    </>
  );
};
